import { assign } from 'xstate';
import { AppBarEvent } from '../../../events';
import { AppBarMachineContext } from '../../../machineContext';

export const name = 'setTargetCollapsed';

export const fn = assign<AppBarMachineContext, AppBarEvent>({
  target: () => 'collapsed',
});

export const action = {
  [name]: fn,
};

export default action;
